import { inject, Injectable } from "@angular/core";
import { CommonProcessTreeColumns, CommonProcessTreeQueryComplexInput, CommonProcessTreeSimpleQueryInput, CommonProcessTreeSortInput, ComparatorOperators, DownloadEvaluationTreeProcessViewGQL, DownloadEvaluationTreeProcessViewMutation, GetCptFiltersGQL, GetCptFiltersQuery, GetProcessEvaluationGQL, GetProcessEvaluationQuery, LegalEntityComplexQueryInput, LegalEntityFields, LegalEntityQueryComplexInput, LegalEntitySimpleQueryInput, LegalEntitySortInput, OperatorInput, OrderTypeInput, PagingInput, RiskMapTreeColumns, RiskMapTreeQueryComplexInput, RiskMapTreeSimpleQueryInput, RiskMapTreeSortInput, UpdateProcessEvaluationGQL, UpdateProcessEvaluationMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";
import { MutationData, unwrapMutationData } from "../shared/graphql-mutation-response.util";

@Injectable({
    providedIn: 'root'
})
export class ProcessEvaluationService {
    private readonly GetProcessEvaluationGQL: GetProcessEvaluationGQL = inject(GetProcessEvaluationGQL);
    private readonly GetCptFiltersGQL: GetCptFiltersGQL = inject(GetCptFiltersGQL);
    private readonly UpdateProcessEvaluationGQL: UpdateProcessEvaluationGQL = inject(UpdateProcessEvaluationGQL)
    private readonly DownloadEvaluationTreeProcessViewGQL: DownloadEvaluationTreeProcessViewGQL = inject(DownloadEvaluationTreeProcessViewGQL)

    getProcessEvaluation(campaignId: string, cptIds: string[], parameters: any, legalEntitiesId: string[]): Observable<GetProcessEvaluationQuery['evaluationTreeProcessView']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.GetProcessEvaluationGQL.fetch({ campaignId, cptIds, query: param.query, sort: param.sort, page: param.page, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.evaluationTreeProcessView))
    }

    getFilters(ids: string[]): Observable<GetCptFiltersQuery['commonProcessTreeFields']> {
        return this.GetCptFiltersGQL.fetch({ ids, active: true, valueChain: null }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.commonProcessTreeFields))
    }

    updateProcessEvaluation(riskMapId: string, riskId: string, impactId: string, likelihoodId: string, icsId: string, legalEntitiesId: string[]): Observable<MutationData<UpdateProcessEvaluationMutation['updateEvaluationTreeProcessView']>> {
        return this.UpdateProcessEvaluationGQL.mutate({ riskId, riskMapId, icsId, impactId, likelihoodId, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.updateEvaluationTreeProcessView), unwrapMutationData('Unable to update the evaluation'))
    }

    downloadProcessEvaluation(
        campaignId: string,
        cptIds: any,
        parameters: any,
        timeZone: string,
        legalEntitiesId: string[]
    ): Observable<DownloadEvaluationTreeProcessViewMutation['downloadEvaluationTreeProcessView']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.DownloadEvaluationTreeProcessViewGQL.mutate({ campaignId, cptIds, timeZone, query: param.query, sort: param.sort, legalEntitiesId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.downloadEvaluationTreeProcessView))
    }
}

export function convertLazyLoadToComplexWithoutPage(parameters: any): { query: CommonProcessTreeQueryComplexInput, sort: CommonProcessTreeSortInput, page: PagingInput } {
    const query: CommonProcessTreeSimpleQueryInput[] = [];

    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_PROCESS_RISKMAP[field as keyof typeof ENUM_PROCESS_RISKMAP]).forEach(key => {

                        let filteredValue: any[] = [];
                        filteredValue = values
                        query.push({
                            field: key as CommonProcessTreeColumns,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: filteredValue
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.Or
                }
            ]
        },
        sort: {
            sortField: ENUM_PROCESS_RISKMAP?.[parameters?.order?.sortField as keyof typeof ENUM_PROCESS_RISKMAP]?.[0] as CommonProcessTreeColumns || CommonProcessTreeColumns.Sort,
            sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 3
        }
    }
}


export const ENUM_PROCESS_RISKMAP = {
    name: [CommonProcessTreeColumns.Name],
    code: [CommonProcessTreeColumns.Code],
    cluster: [CommonProcessTreeColumns.Cluster]
}